import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import { MemosFilters } from '../entities/memos-filters.entity';

@Component({
	selector: 'memos',
	templateUrl: 'memos.html',
	// styleUrls: ['planning-memo.css']
})
export class MemosComponent {
	filtersSubject = new Subject<MemosFilters>();
	
	constructor( //
	) {
	}

	/////////////////////////////////////
	// Gestion des actions utilisateur //
	/////////////////////////////////////
	
	onFilterRequest(filters: MemosFilters) {
		this.filtersSubject.next(filters);
	}
}